import { RefreshToken } from '../modules/auth/redux/AuthCRUD'
import { AxiosHeaders } from 'axios'

export async function GetAPIDomain() {
    let domain = localStorage.getItem('api-domain')

    if (!domain) {
        const response = await fetch('/app-settings/domains')
        const data = await response.json()

        domain = data.domainApi
        localStorage.setItem('api-domain', domain)
    }

    return domain
}

export async function GetAPIHeaders(contentType) {
    let expiry = new Date(Date.parse(localStorage.getItem('expires')))

    if (expiry < new Date()) {
        console.log('Expired')
        const result = await RefreshToken()

        if (result) window.location.reload()
    }

    let accessToken = localStorage.getItem('access-token-v2')
    return new AxiosHeaders({
        'content-type': contentType ? contentType : 'application/json',
        Authorization: 'Bearer ' + accessToken,
    })
}

export async function GetAPIHeadersPatch() {
    let expiry = new Date(Date.parse(localStorage.getItem('expires')))

    if (expiry < new Date()) {
        console.log('Expired')
        const result = await RefreshToken()

        if (result) window.location.reload()
    }

    let accessToken = localStorage.getItem('access-token-v2')

    return new Headers({
        'content-type': 'application/json-patch+json',
        Authorization: 'Bearer ' + accessToken,
    })
}
